<template>

	<div class="app-principal">	
		<div class="app-topo">
      <top-bar :title="tituloComponente"  
        @navigate="navigate" 
        :exibeVoltar="exibeVoltarNaBarraDeTitulo"
        :navigateto="navigateto" historyback="true" :home="true"></top-bar>
    </div>
		<div class="app-centro">
      <transition name="fade">
        <component :is="componente"  @navigate="navigate" :tipocpcr="tipocpcr"/>
      </transition>
    </div>
		<div class="app-rodape">
      <tab-panel @navigate="navigate" ref="tabpanel"></tab-panel>
    </div>
	</div>

</template>

<script>
// @ is an alias to /src
import TopBar from '@/components/layout/TopBar.vue';
import TabPanel from '@/components/layout/TabPanel.vue';
import Cadastros from '@/components/layout/Cadastros.vue';
import Financeiro from '@/components/layout/Financeiro.vue';
import Lembretes from '@/components/layout/Lembretes.vue';
import ContasAPagar from '@/components/layout/ContasAPagar.vue';
import ReceitasDespesas from '@/components/layout/ReceitasDespesas.vue';
import MenuMapaProducao from '@/components/layout/MenuMapaProducao.vue';

export default {
  name: 'Home',
  props: ['opcao'],
  components: {
    TopBar,
    TabPanel,
    Cadastros,
    Financeiro,
    Lembretes,
    'mapaproducao' : MenuMapaProducao,
    'receitasdespesas': ReceitasDespesas,
    'contasapagar': ContasAPagar,
    'contasareceber': ContasAPagar
  },
  created(){
    this.componente = 'cadastros';
    this.tituloComponente = this.getTituloComponente();


    
  },

  mounted(){

    var path = this.$router.currentRoute.path.toLowerCase().slice(1).split('/');
    this.navigate(path.pop());


    if(this.componente=='contasapagar'){
      this.tipocpcr='cp';
    } else if (this.componente=='contasareceber'){
      this.tipocpcr='cr';
    }

  },
  data(){
    return {
      componente: '',
      tituloComponente: '',
      tipocpcr : '',
      exibeVoltarNaBarraDeTitulo : false,
      navigateto : ''
    }
  },

  methods:{
    
    navigate(componenteExibir){
      this.componente = componenteExibir.toLowerCase();
      this.tituloComponente = this.getTituloComponente();

      if ((this.componente=='lembretes')||
          (this.componente=='financeiro')||
          (this.componente=='cadastros')){
            this.$refs.tabpanel.navigateTarget(document.getElementById('tabbar-'+this.componente), true);
      }

    },

    
    getTituloComponente(){

      this.exibeVoltarNaBarraDeTitulo = false;
      this.navigateto = this.componente;
      
      if(this.componente=='lembretes'){
        return 'Lembretes';
      } else if(this.componente=='financeiro'){
        return 'Financeiro';
      } else   if(this.componente=='cadastros'){
        return 'Cadastros';
      } else if(this.componente=='contasapagar'){

        this.tipocpcr='cp';
        this.navigateto = 'financeiro';
        this.exibeVoltarNaBarraDeTitulo = true;

        return 'Contas a pagar';
      } else if(this.componente=='contasareceber'){
        
        this.tipocpcr='cr';
        this.navigateto = 'financeiro';
        this.exibeVoltarNaBarraDeTitulo = true;

        return 'Contas a receber';
      } else if (this.componente=='receitasdespesas'){

        this.navigateto = 'financeiro';
        this.exibeVoltarNaBarraDeTitulo = true;

        return 'Receitas/Despesas';

      } else if (this.componente=='mapaproducao'){

        this.navigateto = 'financeiro';
        this.exibeVoltarNaBarraDeTitulo = true;

        return 'Mapa de Produção';

      } else {
        return ' ';
      }

    }

  }
}
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
      transition: opacity .4s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
      opacity: 0;
    }
    


</style>